import { useMutation, useQueryClient } from '@tanstack/react-query';
import useApiClient from '../../Shared/services/api';
import { deleteArtEvent } from '../service/service';
import { DeleteArtEventResponse } from '../interfaces/editArtEventInterfaces';
import { ArtEventEndpointQueryKeys } from '../../Shared/constants/artEvent/endpoints';
import { useAppContext } from '../../Shared/store/appContext';
import { SET_SELECTED_ART_EVENT_ID } from '../../Shared/store/actions/types';

export const useDeleteArtEventMutation = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  const { state, dispatch } = useAppContext();

  return useMutation<DeleteArtEventResponse | null, Error, string>({
    mutationFn: (artEventId: string) => deleteArtEvent(api, artEventId),
    onSuccess: (_, artEventId) => {
      queryClient.invalidateQueries({
        queryKey: [ArtEventEndpointQueryKeys.GET_ART_EVENTS],
      });

      if (state.selectedArtEventId === artEventId) {
        dispatch({
          type: SET_SELECTED_ART_EVENT_ID,
          payload: null,
        });
      }
    },
  });
};
